export const orderHeaderArr = [
    { title: 'Order Reference Number' },
    { title: 'Order Id' },
    { title: 'Company Name' },
    { title: 'PO Number' },
    { title: 'Requested Date' },
    { title: 'Actual Delivery Date' },
    { title: 'Order Status' },
]

export const pickupOrderHeaderArr = [
    { title: 'Order Reference Number' },
    { title: 'Order Id' },
    { title: 'Company Name' },
    { title: 'PO Number' },
    { title: 'Requested Date' },
    { title: 'Actual Pickup Date' },
    { title: 'Order Status' },
]